import React from "react";
import logo from "../components/images/logo.png";
import email from "../components/images/email.png";
import call from "../components/images/call.png";
import location from "../components/images/location.png";
import { Link } from "react-router-dom";

const LandingFooter = () => {
  return (
    <footer className="bg-[#212121] text-white flex flex-col items-center py-10">
      
      {/* Top Section */}
      <div className="w-full flex items-center justify-around md:flex-col md:gap-8">
        <div className="md:ml-[10vw] flex flex-col gap-5">
          <div className="flex items-center gap-5">
            <img src={logo} alt="Skillop Logo" />
            <h1 className="text-lg font-semibold">SKILLOP</h1>
          </div>

          <div className="flex items-center gap-3">
            <img src={email} alt="Email Icon" />
            <a href="mailto:dtuskillop@gmail.com">
              dtuskillop@gmail.com
            </a>
          </div>

          <div className="flex items-center gap-3">
            <img src={call} alt="Call Icon" />
            <span>+91 9643654899</span>
          </div>

          <div className="flex items-start gap-3">
            <img src={location} alt="Location Icon" />
            <p className="w-[60%]">
              Delhi Technological University, Bawana Road, Shahbad Daulatpur
              Village, Rohini, Delhi 110042
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-5 md:items-start">
          <Link to="/about">ABOUT</Link>
          <Link to="/contact">CONTACT</Link>
          <Link to="/terms-of-service">TERMS OF SERVICE</Link>
          <Link to="/privacy-policy">PRIVACY POLICY</Link>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="mt-8 text-sm text-gray-400">
        © {new Date().getFullYear()} SKILLOP. All rights reserved.
      </div>

    </footer>
  );
};

export default LandingFooter;
